export default __webpack_public_path__ + "static/media/arrow-left.e6eb9be1.svg";